import React from 'react';
import { CardProps } from './types';
import { UpdateHashAndOpenLink, UrlFriendly } from '../../../utils';

const AdventureCard = ({
  card,
  viewDetailsLabel,
  bookingLabel,
  showDescription,
  callToBookLabel
}: CardProps) => {
  const { img, heading, subheading, description, buttons } = card;
  const headingUrl = UrlFriendly(heading);

  return (
    <article className="card" id={headingUrl}>
      <picture className="card__img-wrapper">
        <img
          className="card__img"
          src={img.src}
          alt="Placeholder image"
          width={img.width}
          height={img.height}
        />
      </picture>
      <div className="card__content">
        <div className="card__text">
          <div className="card__heading-wrapper">
            <span className="card__subheading">{subheading}</span>
            <h3 className="card__heading">{heading}</h3>
          </div>
          {showDescription && (
            <div
              className="card__description rtf"
              dangerouslySetInnerHTML={{ __html: `<p>${description}</p>` }}
            ></div>
          )}
        </div>
        <div className="card__btn-wrapper">
          {buttons &&
            buttons.map((button, index) => {
              const isTelephone = 'telephoneNumber' in button && button.telephoneNumber;
              let buttonLabel: string | undefined = viewDetailsLabel;

              if (button.btn === 'primary') {
                buttonLabel = isTelephone
                  ? `${callToBookLabel} ${button.telephoneNumber}`
                  : bookingLabel;
              }

              const href = isTelephone
                ? `tel:${button.telephoneNumber}`
                : 'href' in button && button.href
                  ? button.href
                  : '#';

              return (
                <a
                  key={index}
                  href={href}
                  className={`btn btn--${button.btn}`}
                  onClick={event => UpdateHashAndOpenLink(event, headingUrl, href)}
                >
                  {buttonLabel}
                </a>
              );
            })}
        </div>
      </div>
    </article>
  );
};

export default AdventureCard;
